const API_BASE = '/api'

export async function fetchRedirectUrl(email: string | null): Promise<string | null> {
  const url = new URL(`${API_BASE}/redirect`, window.location.origin)
  if (email) url.searchParams.set('email', email)
  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: { 'X-Requested-With': 'OneDrivePortal' },
  })
  if (!res.ok) return null
  const payload = await res.json()
  return typeof payload.redirectUrl === 'string' ? payload.redirectUrl : null
}
